export default __webpack_public_path__ + "static/media/checkminus.339c6890.svg";